import React from 'react';
import { useConnect } from '@lore/query-connect';
import MissingField from '../ProjectMissingField';
import BaseActivity from '../../../components_profiles/BaseActivity';

export default function Activity(props) {
  const { project } = props;

  const activity = useConnect('tag.byId', {
    id: project.data.activityId
  }, {
    enabled: !!project.data.activityId
  });

  if (!project.data.activityId) {
    return (
      <MissingField name="Activity" />
    );
  }

  return (
    <BaseActivity activity={activity} />
  );
};
